import { render } from "./DataNav.vue?vue&type=template&id=f44badf6&scoped=true"
import script from "./DataNav.vue?vue&type=script&lang=js"
export * from "./DataNav.vue?vue&type=script&lang=js"

import "./DataNav.vue?vue&type=style&index=0&id=f44badf6&scoped=true&lang=css"

import exportComponent from "/usr/local/share/application/bug-finder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f44badf6"]])

export default __exports__